<svg viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect width="80" height="80" fill="white"/>
<g clip-path="url(#clip0_4109_4025)">
<path d="M43.9629 40.246L49.4708 46.5417L56.8772 51.2748L58.1686 40.2847L56.8772 29.54L49.3288 33.6984L43.9629 40.246Z" fill="#00832D"/>
<path d="M12 50.2545V59.6174C12 61.7579 13.7337 63.4917 15.8743 63.4917H25.2371L27.1743 56.4146L25.2371 50.2545L18.8123 48.3174L12 50.2545Z" fill="#0066DA"/>
<path d="M25.2371 17L12 30.2371L18.8123 32.1743L25.2371 30.2371L27.142 24.161L25.2371 17Z" fill="#E94235"/>
<path d="M25.2371 30.2373H12V50.2544H25.2371V30.2373Z" fill="#2684FC"/>
<path d="M65.3352 22.6051L56.8763 29.54V51.2748L65.3739 58.242C66.646 59.2364 68.5056 58.3292 68.5056 56.7117V24.1031C68.5056 22.4662 66.604 21.5687 65.3352 22.6051ZM43.962 40.246V50.2546H25.2363V63.4917H53.002C55.1426 63.4917 56.8763 61.758 56.8763 59.6174V51.2748L43.962 40.246Z" fill="#00AC47"/>
<path d="M53.002 17H25.2363V30.2371H43.962V40.2457L56.8763 29.5462V20.8743C56.8763 18.7337 55.1426 17 53.002 17Z" fill="#FFBA00"/>
</g>
<defs>
<clipPath id="clip0_4109_4025">
<rect width="56.5" height="46.4914" fill="white" transform="translate(12 17)"/>
</clipPath>
</defs>
</svg>
